import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import { PricingClient } from 'src/WebApiController';

export function useGetSellerEventWithVenueByVenueConfigId(
  venueConfigId?: number | null
) {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();

  const shouldQuery = useMemo(() => Boolean(venueConfigId), [venueConfigId]);
  const sellerEventsQuery = useQuery({
    queryKey: ['getSellerEventWithVenueByVenueConfigId', venueConfigId],
    async queryFn() {
      if (!shouldQuery || !venueConfigId) return null;

      return await new PricingClient(
        activeAccountWebClientConfig
      ).getSellerEventWithVenueByVenueConfigId(venueConfigId);
    },
    enabled: shouldQuery,
    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError(
          'PricingClient.getSellerEventWithVenueByVenueConfigId',
          error
        );
      },
    },
  });

  return {
    sellerEventsWithSameVenueConfigId: sellerEventsQuery.data ?? undefined,
    isLoading: sellerEventsQuery.isPending,
  };
}
